type ComponentIdentifier =
  | 'r-text'
  | 'something-else'
  | 'cloudinary-advanced-image'
  | 'r-video'
  | 'r-icon'
  | 'r-button'
  | 'r-divider'
  | 'r-embed'
  | 'r-list'
  | 'r-accordion'
  | 'r-mount';

export const ComponentIdentifiers: Record<string, ComponentIdentifier> = {
  rText: 'r-text',
  somethingElse: 'something-else',
  cloudinaryAdvancedImage: 'cloudinary-advanced-image',
  rVideo: 'r-video',
  rIcon: 'r-icon',
  rButton: 'r-button',
  rDivider: 'r-divider',
  rEmbed: 'r-embed',
  rList: 'r-list',
  rAccordion: 'r-accordion',
  rMount: 'r-mount',
} as const;
